/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {
	useEffect,
	useState
} from "react";

import {
	Button,
	Col,
	FormControl,
	Row
} from "react-bootstrap";

import {config} from "../../../Config";
import {service as AuthService} from "../../../Services/Core/AuthService";

import {useSelector} from "react-redux";
import {GlyphButton} from "../../../Components/Common/ButtonWithIcon";
import {ForgotPasswordPopup} from "../../../../../monitoring/src/Components/Auth/ForgotPasswordPopup";

export const PasswordFieldEditor = (props) => {
	const {
		IsNewModel,
		OnUpdate,
		Data
	} = props;
	
	const {user} = useSelector(state => state.userState);
	
	const [editing, setEditing] = useState(IsNewModel);
	const [displayModal, setDisplayModal] = useState(false);
	
	const [currentPassword, setCurrentPassword] = useState("");
	const [password1, setPassword1] = useState("");
	const [password2, setPassword2] = useState("");
	
	useEffect(() => {
		// if not editing, clear out passwords and notify parent
		if (!editing) {
			setCurrentPassword('');
			setPassword1('');
			setPassword2('');
			OnUpdate(null);
			return;
		}
		
		// if editing, check if passwords match and notify parent
		if (password1 === password2) {
			OnUpdate({
				password: password1,
				current: currentPassword
			});
		} else {
			OnUpdate(false);
		}
	}, [editing, password1, password2, currentPassword]);
	
	const toggleEditing = () => {
		setEditing((prevEditing) => !prevEditing);
	};
	
	const toggleModal = () => {
		setDisplayModal((prev) => !prev);
	};
	
	return (
		<div>
			{
				!IsNewModel ?
					<div className="sb-single-line-with-button-field-editor">
						<Button className="pndlm-button-grey" onClick={toggleEditing}>
							{editing ? "Cancel" : "Change"}
						</Button>
						{ !editing ?
							<GlyphButton
								className="btn btn-link pndlm-image-delete-reset-button"
								glyph="sync"
						        onClick={toggleModal}
							>
								E-mail Reset Link
							</GlyphButton> : <div style={{flexGrow: 1}} ></div>
						}
					</div> :
					null
			}
			{
				editing ?
					<div>
						<Row className="top17">
							<Col xs={12}>
								<FormControl
									autocomplete="current-password"
									type="password"
									placeholder={
										Data.userId !== user?.userId ?
											"Admin Password" :
											"Current Password"
									}
									value={currentPassword || ""}
									onChange={(e) => setCurrentPassword(e.target.value)}
								/>
							</Col>
						</Row>
						<Row className="top17">
							<Col xs={12}>
								<FormControl
									autocomplete="new-password"
									type="password"
									placeholder="Password"
									value={password1 || ""}
									onChange={(e) => setPassword1(e.target.value)}
								/>
							</Col>
						</Row>
						<Row className="top17">
							<Col xs={12}>
								<FormControl
									autocomplete="new-password"
									type="password"
									placeholder="Verify Password"
									value={password2 || ""}
									onChange={(e) => setPassword2(e.target.value)}
								/>
							</Col>
						</Row>
					</div> :
					null
			}
			<ForgotPasswordPopup
				authService={AuthService}
				centered={false}
				className={"sb-login-popup-container"}
				onHide={() => setDisplayModal(false)}
				show={displayModal}
				showDisabledWarning={config.getEnvironment() !== 'prod'}
				showEmailField={false}
				suggestedEmail={Data.email}
			/>
		</div>
	);
};
